import React from 'react'
import { useSelector } from 'react-redux'
import './header.scss'

export default props => {
  const logoParceiro = useSelector(state => state.tipoCadastroReducer.logoParceiro);

  return (
    <header>
      <div className="container">
        <div className="logo-container">
            <img
              className="logo"
              src={props.logoSrc}
              alt={props.logoAlt}
            />
            {
              logoParceiro &&
              <img
                className="logo logo-parceiro"
                src={`data:image/png;base64,${logoParceiro.LogoBase64}`}
                alt="Logo parceiro"
              />
            }
          </div>
      </div>
    </header>
  )
}
